import { render } from "./Worship.vue?vue&type=template&id=61330bb9&scoped=true"
import script from "./Worship.vue?vue&type=script&lang=js"
export * from "./Worship.vue?vue&type=script&lang=js"

import "./Worship.vue?vue&type=style&index=0&id=61330bb9&lang=scss&scoped=true"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61330bb9"]])

export default __exports__